import React from "react";
import { observer, inject } from "mobx-react";
import { ColorOptionsWithAlternate } from "../models/ColorOptionModel";
import ModelPickerStore from "../stores/ModelPickerStore";
import ColorsStore from "../stores/ColorsStore";
import { ModelSelection } from "../models/ModelSelection";

interface ModelPickerProps {
  content: ColorOptionsWithAlternate;
  defaultModel: ModelSelection;
  alternateModel: ModelSelection;
}

interface ModelPickerState {}

interface InjectedProps extends ModelPickerProps {
  ModelPickerStore: ModelPickerStore;
  ColorsStore: ColorsStore;
}

@inject("ModelPickerStore", "ColorsStore")
@observer
class ModelPicker extends React.Component<ModelPickerProps, ModelPickerState> {
  constructor(props) {
    super(props);
  }

  get injected() {
    return this.props as InjectedProps;
  }

  componentDidMount() {
    const { defaultModel } = this.props;
    const { ModelPickerStore } = this.injected;
    ModelPickerStore.toggleModelSelection(defaultModel as ModelSelection);
  }

  render() {
    const { content, defaultModel, alternateModel } = this.props;
    const { ModelPickerStore, ColorsStore } = this.injected;
    ModelPickerStore.setModelValues(defaultModel, alternateModel);

    return (
      <div>
        <div className="form__field customise-car__image-switch-hybrid">
          <div className="form__radio-group">
            <div className="form__radio-group-item">
              <input
                type="radio"
                id="xvRadioButton"
                name="radio-hybrid-group"
                value="XV"
                checked={ModelPickerStore.modelSelection === defaultModel}
                onChange={(e) => {
                  ModelPickerStore.toggleModelSelection(defaultModel);
                  ColorsStore.fetchColorOptions(content.colours);
                }}
              />
              <label htmlFor="xvRadioButton">{defaultModel}</label>
            </div>
            <div className="form__radio-group-item">
              <input
                type="radio"
                id="foresterRadioButton"
                name="radio-hybrid-group"
                value="Forester"
                checked={ModelPickerStore.modelSelection === alternateModel}
                onChange={(e) => {
                  ModelPickerStore.toggleModelSelection(alternateModel);
                  ColorsStore.fetchColorOptions(content.alternateColours);
                }}
              />
              <label htmlFor="foresterRadioButton">{alternateModel}</label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModelPicker;
